
import 'lazysizes';
import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation.min'

import Newsletter from './newsletter'

class NaturalSelections {
    
	constructor() {
		
        this.siteHeader = document.querySelector('.site-header')
		this.toggleMenuButton = document.querySelector('.site-header__toggle-menu-button')
		this.mobileMenuContainer = document.querySelector('.site-header__mobile-navigation')
		this.prevScrollPosition = 0;

        this.scrollHandler = this.scrollHandler.bind(this);

	}

	scrollHandler(e) {

        if ( document.body.classList.contains('menu-is-open') ) {
            return
        }

        let newPosition = window.scrollY,
			offset = 50;

        if( newPosition > offset ) {
            this.siteHeader.classList.add('site-header--solid');
            if ( newPosition > this.prevScrollPosition+25 ) {
                this.siteHeader.classList.add('site-header--hidden');
            } 
            if ( newPosition < this.prevScrollPosition-25 ) {
                this.siteHeader.classList.remove('site-header--hidden');
            }
        } else {
            this.siteHeader.classList.remove('site-header--solid','site-header--hidden');
        }
        this.prevScrollPosition = newPosition;

    }

	init() {
        
		// this.scrollHandler();
        window.addEventListener('scroll', this.scrollHandler)

        this.toggleMenuButton.addEventListener('click', e => {

            if ( document.body.classList.contains('menu-is-open') ) {
				this.toggleMenuButton.setAttribute('aria-expanded', false);
                document.body.classList.remove('menu-is-open')
            } else {
				this.toggleMenuButton.setAttribute('aria-expanded', true);
                document.body.classList.add('menu-is-open')
            }

        })
        
        const newsletter = new Newsletter()
        newsletter.init()

	}

}

const site = new NaturalSelections();
site.init();
